import React from 'react';
// import { NavLink } from 'react-router-dom';

import DominionPost from '../img/olddominion_1.png';
import SouthlandTimes from '../img/old-southland-times.png'
import Arrowwhite from '../img/arrowwhite.svg';
import DailyNews from '../img/old-daily-news.png'

class NationalBody extends React.Component {
    constructor(){
        super();

        this.state = {
            getYear:  this.getYear(),
            currentDate: this.getCurrDate(),
            currentMonth: this.getCurrMonth(),
            currentDay: this.getCurrDay() 
        };
        this.getYear = this.getYear.bind(this)
        this.getCurrDate =this.getCurrDate.bind(this)
        this.getCurrDay = this.getCurrDay.bind(this)
        this.getCurrMonth = this.getCurrMonth.bind(this)
        this.toTop = this.toTop.bind(this)
    }
    getYear(){
        return new Date().getFullYear()
    }
    getCurrDate(){
        return new Date().getDate()
    }
    getCurrDay(){
        let days =["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return days[new Date().getDay()]
    }
    getCurrMonth(){
        let monts = ["January", "February","March","April","May","June","July","August","September","October","November","December"];
        return monts[new Date().getMonth()]
    }
    toTop(){
        document.body.scrollTop =0;
        document.documentElement.scrollTop = 0;
    }
    render() {
       return (
        <div>
            <div className="custom_bodycontainer__mainpage--header">
            <h3 className="custom_bodycontainer__mainpage--header---title">national news</h3>
       <div><span id="getDay" className="custom_bodycontainer__mainpage--header---currdate">{this.state.currentDay}</span><span className="custom_bodycontainer__mainpage--header---currdate" id="getDate">, {this.state.currentDate} {this.state.currentMonth} </span><span className="getYear custom_bodycontainer__mainpage--header---currdate">{this.state.getYear}</span></div>
            </div>
            <div className="custom_bodycontainer__mainpage--body">
            <div className="custom_bodycontainer__mainpage--body---label">
            <div className="custom_bodycontainer__mainpage--body---label--colorsection2"></div>
            <div className="custom_bodycontainer__mainpage--body---label--textsection2 pointernone">national news</div>
            </div>
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox">
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox---storiesbox">
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox---storiesbox--each">
                <h2 className="articlepriview--topbigtitle">Stuff is 20 annnnn</h2>
                <h6 className="articlepriview--date">27 JUNE 2020</h6>
                <p className="articlepriview--p">MOSCOW (Reuters): Calmer seas allowed rescuers to begin an operation to evacuate 116 sailors from a nuclear submarine trapped at the bottom of the sea on Tuesday, Russian Defence Minister Igor Sergeyev was quoted as saying.</p>
                <a href="" target="_blank" className="custom_bodycontainer__mainpage--body--homecontentsBox---readmore" rel="noopener noreferrer"><span>read more</span></a>
                <img className="newspaperlogo" src={DailyNews} alt="old-dailynews-logo"/>
            </div>
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox---storiesbox--each">
                <h2 className="articlepriview--title">Stuff is 20 years old</h2>
                <h6 className="articlepriview--date">27 JUNE 2020</h6>
                <p className="articlepriview--p">MOSCOW (Reuters): Calmer seas allowed rescuers to begin an operation to evacuate 116 sailors from a nuclear submarine trapped at the bottom of the sea on Tuesday, Russian Defence Minister Igor Sergeyev was quoted as saying.</p>
                <a href="" target="_blank" className="custom_bodycontainer__mainpage--body--homecontentsBox---readmore" rel="noopener noreferrer"><span>read more</span></a>
                <img className="newspaperlogo" src={SouthlandTimes} alt="southlandtimeslogod"/>
            </div>
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox---storiesbox--each">
                <h2 className="articlepriview--title">Stuff is 20 years old</h2>
                <h6 className="articlepriview--date">27 JUNE 2020</h6>
                <p className="articlepriview--p">MOSCOW (Reuters): Calmer seas allowed rescuers to begin an operation to evacuate 116 sailors from a nuclear submarine trapped at the bottom of the sea on Tuesday.</p>
                <a href="" target="_blank" className="custom_bodycontainer__mainpage--body--homecontentsBox---readmore" rel="noopener noreferrer"><span>read more</span></a>
                <img className="newspaperlogo" src={DominionPost} alt="dominionpostlogo"/>
            </div>
            </div>
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox--imgstorybox">
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox--imgstorybox---img"></div>
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox--imgstorybox---linkbox">
                <p className="imagearticle--p">WAITING FOR A BITE: Timaru man Russell Ennis was rewarded for his early start on the opening day of the whitebait season with six precious whitebait.</p>
                <p className="imagearticle--whomade">JOHN BISSET/Timaru Herald</p>
                <a href="" target="_blank" className="custom_bodycontainer__mainpage--body--homecontentsBox---readmore custom_bodycontainer__mainpage--body--homecontentsBox---readmoreimagearticle" rel="noopener noreferrer"><span>read more</span></a>
            </div>
            </div>
            </div>
            <div className="custom_bodycontainer__mainpage--body--nationalbox">
            <div className="custom_bodycontainer__mainpage--body---label">
            <div className="custom_bodycontainer__mainpage--body---label--colorsection2">
            </div>
            <div className="custom_bodycontainer__mainpage--body---label--textsection2 pointernone">todd under fire</div>
            </div>
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox---storiesbox">
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox---storiesbox--each">
                <h2 className="articlepriview--title">Stuff is 20 years old</h2>
                <h6 className="articlepriview--date">27 JUNE 2020</h6>
                <p className="articlepriview--p">MOSCOW (Reuters): Calmer seas allowed rescuers to begin an operation to evacuate 116 sailors from a nuclear submarine trapped at the bottom of the sea on Tuesday, Russian Defence Minister Igor Sergeyev was quoted as saying.</p>
                <a href="" target="_blank" className="custom_bodycontainer__mainpage--body--homecontentsBox---readmore" rel="noopener noreferrer"><span>read more</span></a>
            </div>
            <div className="custom_bodycontainer__mainpage--body--homecontentsBox---storiesbox--each">
                <h2 className="articlepriview--title">Stuff is 20 years old</h2>
                <h6 className="articlepriview--date">27 JUNE 2020</h6>
                <p className="articlepriview--p">MOSCOW (Reuters): Calmer seas allowed rescuers to begin an operation to evacuate 116 sailors from a nuclear submarine trapped at the bottom of the sea on Tuesday, Russian Defence Minister Igor Sergeyev was quoted as saying.</p>
                <a href="" target="_blank" className="custom_bodycontainer__mainpage--body--homecontentsBox---readmore" rel="noopener noreferrer"><span>read more</span></a>
            </div>
            </div>
            </div>
            </div>
            <div className="custom_bodycontainer__mainpage--body---topbuttonbox">
            <div className="custom_bodycontainer__mainpage--body---topbuttonbox--colourbar">
            <img className="custom_bodycontainer__mainpage--body---topbuttonbox--colourbar---arrow" src={Arrowwhite} alt="" />
            </div>
            <span onClick={this.toTop} className="topbuttontext">top of page</span>
            </div>
        </div>
       );
    }
}

export default NationalBody ;